export const getMessagePayload = (polygon, name) => {
    return {
        polygon: polygon,
        name: name
     };
};